export type MaintenanceT = {
  maintenanceMode: boolean;
  maintenanceMessage: string;
};

const maintenance: MaintenanceT = {
  maintenanceMode: false,
  maintenanceMessage: '',
};

export default maintenance;
